import React from 'react'

import { Box, Container } from '@mui/material'
import logo1 from "../assets/a1.png"
import logo2 from "../assets/logo2.png"
import logo3 from "../assets/logo3.png"
import logo4 from "../assets/logo4.png"
import logo5 from "../assets/logo5.png"
import logo6 from "../assets/logo6.png"
import logo7 from "../assets/logo7.png"
import logo8 from "../assets/logo8.png"
import logo9 from "../assets/logo9.png"
import logo10 from "../assets/logo10.png"
import logo11 from "../assets/logo11.png"
import logo12 from "../assets/logo12.png"
import logo13 from "../assets/logo13.png"
import logo14 from "../assets/logo14.png"
import ArrowBtn from './ArrowBtn'
const ImagesLogo = () => {
  return (
    <>
      <Box className="images_main_div">
        <Box className="branding_main">
          <h1 className='imgH1'>
            <span style={{ color: "#604CD4" }}> WeCare</span> are experts in the  <br />following boilers and more!
          </h1>
          <Container maxWidth="xl" className="main_imges">

            <img src={logo1} alt="logo" width={100} />
            <img src={logo2} alt="logo" width={120} />
            <img src={logo3} alt="logo" width={120} />
            <img src={logo4} alt="logo" width={100} />
            <img src={logo5} alt="logo" width={120} />
            <img src={logo8} alt="logo" width={80} />
            <img src={logo7} alt="logo" width={80} />
            <img src={logo6} alt="logo" width={150} />
            <img src={logo9} alt="logo" width={80} />
            <img src={logo10} alt="logo" width={100} />
            <img src={logo11} alt="logo" width={100} />
            <img src={logo12} alt="logo" width={100} />
            <img src={logo13} alt="logo" width={100} />
            <img src={logo14} alt="logo" width={100} />

          </Container>
        
        </Box>
        
      </Box>
    </>
  )
}

export default ImagesLogo
